export * as Lyzenga from './lyzenga';
/**
 * @function addpSDB
 * @description Computes a pseudo satellite-derived-bathymetry (pSDB) band as the log-ratio of two
 * reflectance bands: pSDB = log(n*band1) / log(n*band2), per Stumpf et al. (2003) and
 * Caballero & Stumpf (2019). Used as the single predictor for Model 2 (Stumpf), and applied
 * twice with different band pairs (blue/green, blue/red) as the green/red predictors blended
 * in Model 3 (Caballero & Stumpf).
 * 1. Selects band1 and band2 from the input image.
 * 2. Masks out pixels where either reflectance is <= 0, since log is undefined there.
 * 3. Divides log(band1) by log(band2) over the masked pixels and renames the result.
 * @param {ee.Image} image - Target image containing the two reflectance bands.
 * @param {Array<string>} bands - [band1, band2] names to use in the ratio (e.g. blue/green).
 * @param {string} [bandName='pSDB'] - Name for the output ratio band.
 * **Called by:
 * @see {model2Apply}
 * @see {model3Apply}
 * @see {reducePseudoFromCollection}
 * @see {reprocessCharts}
 * @memberof module:Bathymetry
 * @returns {ee.Image} Single-band image with the log-ratio, masked where inputs were <= 0.
 */
export const addpSDB = (image, bands, bandName = 'pSDB') => {
  const b1 = image.select(bands[0]);
  const b2 = image.select(bands[1]);
  const posMask = b1.gt(0).and(b2.gt(0));
  const p = b1.updateMask(posMask).log().divide(b2.updateMask(posMask).log()).rename(bandName);
  return p;
};
